import RequestMethod from "@/models/client/RequestMethod";
import RestResponse from "@/models/client/RestResponse";
import {
  EntraDirectoryConsentUrl,
  EntraDirectorySyncStatus,
  EntraDirectorySyncTenantResult,
} from "@/models/entraDirectorySync/EntraDirectorySync";
import { RestClient } from "./restClient";

export type EntraDirectorySyncServiceType = {
  getStatus: (tenantId: string) => RestResponse<EntraDirectorySyncStatus>;
  getConsentUrl: (tenantId: string) => RestResponse<EntraDirectoryConsentUrl>;
  runDryRun: (
    tenantId: string
  ) => RestResponse<EntraDirectorySyncTenantResult>;
  approveLive: (tenantId: string) => RestResponse<void>;
  disableLive: (tenantId: string) => RestResponse<void>;
  runLive: (
    tenantId: string,
    expectedRemovals: number | null
  ) => RestResponse<void>;
};

const entraDirectorySyncServices = (
  client: RestClient,
  tenantPath: string
): EntraDirectorySyncServiceType => ({
  getStatus: async (tenantId: string) =>
    client.fetch<EntraDirectorySyncStatus>(
      RequestMethod.GET,
      `${tenantPath}/${tenantId}/entra-directory-sync/status`
    ),
  getConsentUrl: async (tenantId: string) =>
    client.fetch<EntraDirectoryConsentUrl>(
      RequestMethod.GET,
      `${tenantPath}/${tenantId}/entra-directory-sync/consent-url`
    ),
  runDryRun: async (tenantId: string) =>
    client.fetch<EntraDirectorySyncTenantResult>(
      RequestMethod.POST,
      `${tenantPath}/${tenantId}/entra-directory-sync/dry-run`
    ),
  approveLive: async (tenantId: string) =>
    client.fetch<void>(
      RequestMethod.POST,
      `${tenantPath}/${tenantId}/entra-directory-sync/approve-live`
    ),
  disableLive: async (tenantId: string) =>
    client.fetch<void>(
      RequestMethod.POST,
      `${tenantPath}/${tenantId}/entra-directory-sync/disable-live`
    ),
  runLive: async (tenantId: string, expectedRemovals: number | null) =>
    client.fetch<void>(
      RequestMethod.POST,
      `${tenantPath}/${tenantId}/entra-directory-sync/run-live`,
      { expectedRemovals }
    ),
});

export default entraDirectorySyncServices;
